import React from 'react';
import { getData, deleteData, } from '../../../core/HttpAction';
import Table from '../../../core/Table'; 
import {withRouter} from 'react-router-dom';
const Url='/staff';

const PhotoColumn=({row})=>{  
    return row.photo?<img style={{width:'50px',height:'50px'}} src={row.photo} alt="user avatar"/>:'';
}; 
const columns=[
    {
        key:'photo',
        displayName:'Photo',
        Cell:PhotoColumn
    },
    {
        key:'name',
        displayName:'Name'
    },
    {
        key:'id_no',
        displayName:'ID No'
    }
     
];
  
class ListPage extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            params:{
                search_term: '',
                startDate: '',
                endDate:'', 
                limit:10,
                page:1
            }, 
            data:[],
            preloader:true,
        };
        this.fetchData = this.fetchData.bind(this);  
        this.handleFetch = this.handleFetch.bind(this);  
        this.delete = this.delete.bind(this);  
    }
 
    componentDidMount(){
        this.fetchData();
    }

 
    fetchData(){
        getData(Url,this.state.params).then((res)=>{ 
            this.setState({data:res.data,preloader:false}); 
        });
    }

    handleFetch(params){
        this.setState({params:{...params},preloader:true},()=>{
            this.fetchData();
        });
    }

    delete(id){
        let page=1;
        this.setState({preloader:true,params:{...this.state.params,page}});
        deleteData(Url+'/'+id).then((res)=>{
            if(res.data.status===200){
                this.fetchData();
            }else{
                alert('Not delete');
                this.setState({preloader:false});
            }
        });   
    }
    render() {
        let {preloader,data}=this.state; 
        return (
            <Table
                data={data}
                handleFetch={this.handleFetch.bind(this)}
                preloader={preloader}
                permission="student"
                title="Staff"
                columns={columns}
                primaryKey="staff_id"
                addEditUrl={`${this.props.match.url}-action`} 
                delete={this.delete.bind(this)}
            /> 
        );
    }
}
 
export default  withRouter(ListPage); 



// WEBPACK FOOTER //
// ./src/components/Staff/Staff/index.js